exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.info-box {\n  /*cursor: pointer;*/\n}\n.info-box-content {\n  vertical-align: middle;\n  display: inherit;\n}\n.fullCanvas {\n  width: 100%;\n}\n.info-box-text {\n  margin-bottom: 12px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-2628c90d","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/Project.vue
// module id = 362
// module chunks = 1